module.exports = __webpack_public_path__ + "static/media/026-dentist tools.b84a07a0.svg";